import { Nullable } from "@/api/ApiClient";

export type InterestEntryFormData = Nullable<{
    id: string | undefined,
    numero: number,
    days: number,
    amount: number,
    anulado: boolean,
    created: string,

    currencyId: string,
    currency: any,
    invoiceId: string,
    invoice: any,
    settlementId: string,
    settlement: any,
    settlementInterestId: string,
    settlementInterest: any,
    recibeId: string,
    recibe: any,
}>;

export const InterestEntryRelatedAttributes: Array<keyof InterestEntryFormData> = ["currency", "invoice", "settlement", "settlementInterest", "recibe"];